'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useReducer, } from 'react';
var ActionType;
(function (ActionType) {
    ActionType[ActionType["NOTIFICATION_CREATED"] = 0] = "NOTIFICATION_CREATED";
    ActionType[ActionType["NOTIFICATION_REMOVED"] = 1] = "NOTIFICATION_REMOVED";
})(ActionType || (ActionType = {}));
const reducer = (state, action) => {
    switch (action.type) {
        case ActionType.NOTIFICATION_CREATED: {
            return [...state, action.data];
        }
        case ActionType.NOTIFICATION_REMOVED: {
            return state.filter(({ handle }) => handle !== action.data.handle);
        }
    }
};
const NotificationsContext = createContext(null);
const initialState = [];
const NotificationsProvider = ({ children }) => {
    const [notifications, dispatch] = useReducer(reducer, initialState);
    const createNotification = useCallback((type, handle, substitutions = {}, duration = 5000, cb = () => { }) => {
        const data = { type, handle, duration, substitutions };
        dispatch({ type: ActionType.NOTIFICATION_CREATED, data });
        cb(handle);
    }, [dispatch]);
    const removeNotification = useCallback((handle, cb = () => { }) => {
        const data = { handle };
        dispatch({ type: ActionType.NOTIFICATION_REMOVED, data });
        cb();
    }, [dispatch]);
    const value = useMemo(() => ({ createNotification, removeNotification, notifications }), [createNotification, removeNotification, notifications]);
    return (_jsx(NotificationsContext.Provider, { value: value, children: children }));
};
function useNotifications() {
    const context = useContext(NotificationsContext);
    if (!context)
        throw new Error('useNotifications requires a context!');
    return context;
}
export { NotificationsProvider, useNotifications };
//# sourceMappingURL=notifications.js.map